import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
import { AppConstants } from '../shared/app.constants';
var SettingsService = /** @class */ (function () {
    function SettingsService(http, auth, appConstants) {
        this.http = http;
        this.auth = auth;
        this.appConstants = appConstants;
    }
    SettingsService.prototype.getStoreTimings = function (storeId) {
        var url = environment.apiBase + ("stores/" + storeId + "/timings");
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.get(url, headers).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    SettingsService.prototype.addNewTiming = function (body) {
        var url = environment.apiBase + ("stores/" + body.store + "/timings");
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    SettingsService.prototype.updateStoreTimings = function (body) {
        var url = environment.apiBase + ("stores/" + body.storeId + "/timings");
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.put(url, { timings: body.timings }, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    SettingsService.prototype.getStoreDetails = function (storeId) {
        var url = environment.apiBase + ("stores/" + storeId);
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.get(url, headers).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    SettingsService.prototype.updateStoreDetails = function (body) {
        var url = environment.apiBase + ("stores/" + body.id);
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.put(url, body.event, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return SettingsService;
}());
export { SettingsService };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/settings/settings.service.ts.pre-build-optimizer.js